import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { Plus } from 'lucide-react';
import { productHooks } from '../hooks';
import { ProductList } from '../components/ProductList';
import { ProductDetailDrawer } from '../components/ProductDetailDrawer';
import { PageHeader } from '../../../components/layout/PageHeader';
import { Button } from '../../../components/ui/Button';
import { useDrawerParam } from '../../../lib/hooks';

export function ProductRegistryPage() {
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const { id: selectedProductCode, open, close } = useDrawerParam('drawer');
  const limit = 20;

  const { data: listResponse, isLoading, error } = productHooks.useList({ page, limit });
  const { data: detailResponse } = productHooks.useGet(selectedProductCode || '', {
    enabled: !!selectedProductCode,
  });

  return (
    <div className="flex flex-col w-full h-full" style={{ viewTransitionName: 'page-body' }}>
      <PageHeader
        title="Product Registry"
        action={
          <Button variant="primary" onClick={() => navigate({ to: '/admin/products/new' as never })}>
            <Plus className="w-4 h-4 mr-2" />
            New Product
          </Button>
        }
      />
      <div className="flex-1 w-full min-h-0">
        <ProductList
          data={listResponse?.data || []}
          total={listResponse?.meta.total || 0}
          page={page}
          limit={limit}
          onPageChange={setPage}
          onRowClick={(p) => open(p.productCode)}
          loading={isLoading}
          error={error?.message}
        />

        <ProductDetailDrawer
          product={detailResponse?.data || null}
          open={!!selectedProductCode}
          onClose={close}
        />
      </div>
    </div>
  );
}
